import React, { useEffect, useState, createContext, useContext } from 'react';
import { BankAccount, Transaction } from '../types/banking';
import { bankAccounts, transactions } from '../utils/bankingSeedData';
interface BankingContextType {
  accounts: BankAccount[];
  transactions: Transaction[];
  getAccountsByCompanyId: (companyId: string) => BankAccount[];
  getAccountById: (accountId: string) => BankAccount | undefined;
  getTransactionsByAccountId: (accountId: string) => Transaction[];
}
const BankingContext = createContext<BankingContextType | undefined>(undefined);
export function BankingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [accounts] = useState<BankAccount[]>(bankAccounts);
  const [allTransactions] = useState<Transaction[]>(transactions);
  const getAccountsByCompanyId = (companyId: string) => {
    return accounts.filter(acc => acc.company_id === companyId);
  };
  const getAccountById = (accountId: string) => {
    return accounts.find(acc => acc.id === accountId);
  };
  const getTransactionsByAccountId = (accountId: string) => {
    const account = getAccountById(accountId);
    if (!account) return [];
    return allTransactions.filter(txn => txn.account_id === account.account_id).sort((a, b) => b.date.getTime() - a.date.getTime());
  };
  const value: BankingContextType = {
    accounts,
    transactions: allTransactions,
    getAccountsByCompanyId,
    getAccountById,
    getTransactionsByAccountId
  };
  return <BankingContext.Provider value={value} data-id="element-409">{children}</BankingContext.Provider>;
}
export function useBanking(): BankingContextType {
  const context = useContext(BankingContext);
  if (!context) {
    throw new Error('useBanking must be used within a BankingProvider');
  }
  return context;
}